import { toastAlert } from "../../utils/AlertContext";
import { clippingErrorAlert } from "../../utils/clippingErrorAlert";
import { postReplacedClippingURL } from "../../utils/ConstantsURL";

export const useGenerateReplacedClipping = (token, addToDownloadQueue) => {
  const base64ToBlob = (base64, mimeType) => {
    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], { type: mimeType });
  };

  const generateReplacedClipping = async (
    id_documento,
    fecha,
    nombre_documento,
    onClose
  ) => {
    toastAlert("Generando Reemplazo de contenido...", "info");
    if (onClose) onClose();

    try {
      const response = await fetch(postReplacedClippingURL(), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          fecha,
          id_documento,
          nombre_documento,
        }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Error al generar reemplazo de contenido");
      }
      const data = await response.json();

      const { content, filename, mimeType } = data.document;
      const blob = base64ToBlob(content, mimeType);
      const url = window.URL.createObjectURL(blob);

      const generatedAt = new Date().toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
      });
      const currentDate = new Date().toLocaleDateString("en-GB");

      addToDownloadQueue({
        id_documento,
        nameDocument: `Contenido_${filename}.pdf`,
        fecha: currentDate,
        generatedAt,
        url,
      });

      toastAlert("Reemplazo de contenido generado y añadido a la cola de descargas", "success");
    } catch (error) {
      toastAlert("Error al generar el Reemplazo de contenido: " + error, "error");
      console.error(error);
      clippingErrorAlert({
        documentName: nombre_documento,
        error: error.message,
      });
    }
  };

  return { generateReplacedClipping };
};
